import { render, staticRenderFns } from "./baseRouter.vue?vue&type=template&id=1634796e&scoped=true&"
import script from "./baseRouter.vue?vue&type=script&lang=js&"
export * from "./baseRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1634796e",
  null
  
)

export default component.exports